// Shared display formatters. Money always shows thousands separators + 2 decimals (owner
// preference, s58) — every surface uses formatMoney so amounts never drift ($10,000.00, not
// $10000.00). Negative amounts render with a leading minus inside the sign (-$1,200.00).
export function formatMoney(n: number): string {
  const abs = Math.abs(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${n < 0 ? '-' : ''}$${abs}`;
}
